import React from 'react';

interface Props {
  className?: string;
}

// An animation illustrating that the user can scroll down.
// Use this on full height sections to tell them that they can navigate down.
// Some users might be stuck or won't discover the content below otherwise.

const ScrollIndicator: React.FC<Props> = ({ className }) => {
  return (
    <div className={`mouse_scroll ${className}`}>
      <div className="mouse">
        <div className="wheel"></div>
      </div>
      <div>
        <span className="m_scroll_arrows m_scroll_arrow_one"></span>
        <span className="m_scroll_arrows m_scroll_arrow_two"></span>
        <span className="m_scroll_arrows m_scroll_arrow_three"></span>
      </div>
    </div>
  );
};

export default ScrollIndicator;
